export const langData = {
  account: {
    'login': '登录',
    'account': '账户'
  }
}

const lang = require.context('@/lang', true, /\.json$/)
lang.keys().map(v => {
  const name = v.split('/')[1]
  langData[name] = require(`@/lang/${name}/zh-cn.json`)
})

export default {
  langData
}



// WEBPACK FOOTER //
// ./src/lang/zh-cn.js